module.exports = __webpack_public_path__ + "static/media/10-Y.50bf0d92.mp3";